"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeFormArray = void 0;
/**
 * Used for serializing form data. Similar to jQuery's $().serialize() method.
 *
 * @param form
 */
function serializeFormArray(form) {
    var _a, _b;
    const objects = [];
    if (typeof form === 'object' && form.nodeName.toLowerCase() === 'form') {
        const fields = form.getElementsByTagName('input');
        for (let i = 0; i < fields.length; i++) {
            if (fields[i].getAttribute('type') === 'checkbox' && !fields[i].getAttribute('checked')) {
                continue;
            }
            objects[objects.length] = {
                name: ((_a = fields[i]) === null || _a === void 0 ? void 0 : _a.getAttribute('name')) || '',
                value: ((_b = fields[i]) === null || _b === void 0 ? void 0 : _b.value) || '',
            };
        }
    }
    return objects;
}
exports.serializeFormArray = serializeFormArray;
